import React from "react";
import "./styles/PaymentFailed.css";
import { BiSolidErrorCircle } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import "../../localisation/index"

const PaymentFailed = () => {
  const {t} = useTranslation()
  return (
    <div className="payment-conf__container component">
      <BiSolidErrorCircle className="payment-conf__icon" />
      <p className="payment-conf__msg">
        {t("paymentFailed")}
      </p>
    </div>
  );
};

export default PaymentFailed;
